/**
 * Barrel da pasta student-profile.
 *
 * Exporta os sub-componentes e helpers usados pela tela
 * `app/(personal)/students/[id].tsx`. Mantém os imports do
 * orquestrador limpos:
 *
 *   import { ProfileHeader, InfoSection, ... } from '@/components/student-profile';
 */

export { ProfileHeader } from './ProfileHeader';
export { InfoSection } from './InfoSection';
export { TextFieldSection } from './TextFieldSection';
export { EngagementSection } from './EngagementSection';
export { HistorySection } from './HistorySection';
export { FeedbackSection } from './FeedbackSection';
export { AISuggestionSection } from './AISuggestionSection';
export { DocumentsSection } from './DocumentsSection';
export { RoutinesSection } from './RoutinesSection';
export { FinanceSection } from './FinanceSection';
export { AssessmentSection } from './AssessmentSection';
export { StatusActions } from './StatusActions';
export { OnboardingModal } from './OnboardingModal';
export { PaymentModal } from './PaymentModal';

export { studentToForm, type EditForm } from './helpers';
